import React from "react";
import "./style.scss";
import {CPreloader} from "../../../UI";

export default ({visible}) => {
    if (!visible) {
        return null;
    }

    return (
        <div className={"stream-player-buffering"}>
            <CPreloader isFullscreen />
        </div>
    );
}
